import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../utils/electronAPI';

export const getClientsContent = createAsyncThunk(
    'clients/getClientsContent',
    async (_, { rejectWithValue }) => {
        try {
            return await api.getClients();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const clientSlice = createSlice({
    name: 'clients',
    initialState: { isLoading: false, clients: [], error: null },
    reducers: {
        addNewClient: (state, action) => {
            state.clients.push({ ...action.payload, is_deleted: 0 });
        },
        updateClient: (state, action) => {
            const idx = state.clients.findIndex(c => c.id === action.payload.id);
            if (idx !== -1) state.clients[idx] = { ...state.clients[idx], ...action.payload };
        },
        deleteClient: (state, action) => {
            state.clients = state.clients.map(c =>
                c.id === action.payload.id ? { ...c, is_deleted: 1 } : c
            );
        },
        archiveClient: (state, action) => {
            state.clients = state.clients.map(c =>
                c.id === action.payload.id ? { ...c, is_archived: 1 } : c
            );
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getClientsContent.pending, (state) => { state.isLoading = true; })
            .addCase(getClientsContent.fulfilled, (state, action) => {
                state.clients = action.payload || [];
                state.isLoading = false;
            })
            .addCase(getClientsContent.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { addNewClient, updateClient, deleteClient, archiveClient } = clientSlice.actions;
export default clientSlice.reducer;
